import styled from "@emotion/styled"
import CustomBgImage from "../../components/custom-bg-image/custom-bg-image.component"
import { Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Section = styled(CustomBgImage)`
  background: #f7fafa;
  position: relative;
  overflow: unset;
  /* background-image: url("https://cms.copia.aftershock.agency/wp-content/uploads/2023/12/pattern-4.png");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden; */
`

export const LeftWrapper = styled.div`
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  padding-top: 2.5rem;

  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: 10rem;
    padding-bottom: 10rem;
  }
`

export const RightWrapper = styled.div`
  position: relative;
  -ms-overflow-style: none;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }

  display: flex;
  flex-direction: column;
  padding-bottom: 6.25rem;
  
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-bottom: 10rem;
  }
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.tertiary.light};
  font-size: 0.875rem;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.42px;
  text-transform: uppercase;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: ${({ theme }) => theme.typography.pxToRem("15")};
    letter-spacing: 0.45px;
  }
`

export const Description = styled.div`
  color: ${({ theme }) => theme.palette.primary.dark};
  font-size: ${({ theme }) => theme.typography.pxToRem("22")};
  font-weight: 450;
  line-height: 2.125rem;
  margin-top: 1rem;

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 1.5rem;
    line-height: 2.25rem;
    margin-top: 1.25rem;
    max-width: 555px;
  }

  p {
    :first-of-type {
      margin-top: 0;
    }

    :last-of-type {
      margin-bottom: 0;
    }
  }
`

export const ItemWrapper = styled.div`
  :nth-of-type(1) {
    .image {
      width: 105px;

      ${({ theme }) => theme.breakpoints.up("md")} {
        width: 132px;
      }
    }
  }

  :nth-of-type(2) {
    .image {
      width: 220px;

      ${({ theme }) => theme.breakpoints.up("md")} {
        width: 282px;
      }
    }
  }

  :nth-of-type(3) {
    .image {
      width: 122px;

      ${({ theme }) => theme.breakpoints.up("md")} {
        width: 152px;
      }
    }
  }

  :nth-of-type(4) {
    .image {
      width: 181px;

      ${({ theme }) => theme.breakpoints.up("md")} {
        width: 226px;
      }
    }
  }

  img {
    transition: transform 0.3s ease-in-out;
  }

  :hover {
    img {
      transform: scale(1.1);
    }
  }
  :not(:last-child){
    padding-bottom: 3rem;
    ${({ theme }) => theme.breakpoints.up("md")} {
      padding-bottom: ${({ theme }) => theme.typography.pxToRem("130")};
    }
  }
`

export const FadeOverlay = styled.div`
  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 460px;
    position: sticky;
    position: -webkit-sticky;
    top: 100px;
    left: 0;
    width: 100%;
    height: 15%;
    min-height: 100px;
    background: linear-gradient(180deg,
    #f7fafa 0%,
    rgba(247, 250, 250, 0) 100%);
    z-index: 2;
  }
`
export const ItemImage = styled(CustomImage)``

export const ItemTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.75rem;
  margin-top: 2rem;

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 1.5rem;
    line-height: 1.875rem;
    margin-top: 3rem;
  }
`

export const ItemDescription = styled.div`
  color: ${({ theme }) => theme.palette.primary.main};
  margin-top: 0.75rem;
  /* margin-bottom: 3rem; */

  ${({ theme }) => theme.breakpoints.up("md")} {
      /* margin-bottom: ${({ theme }) => theme.typography.pxToRem("130")}; */
    font-size: ${({ theme }) => theme.typography.pxToRem("17")};
    line-height: ${({ theme }) => theme.typography.pxToRem("26")};
  }

  p {
    :first-of-type {
      margin-top: 0;
    }

    :last-of-type {
      margin-bottom: 0;
    }
  }

  a {
    opacity: 0.9;
    color: ${({ theme }) => theme.palette.primary.main};
    text-decoration-line: underline;
  }
`

export const Pattern = styled.div`
  position: absolute;
`
